export const SEARCH_PATH = '/baumaschinen-mieten/';
export const CIRCUMFERENCE_EARTH = 40075;
